import { useGetFeatureLazyQuery as _useGetFeatureLazyQuery, useGetFeatureQuery as _useGetFeatureQuery, useSetTscliCommandMutation as _useSetTscliCommandMutation, } from '../generated/graphql-types';
export const useGetFeatureQuery = (featureName, viewMode) => {
    const { data, error, loading } = _useGetFeatureQuery({
        variables: {
            featureName,
            viewMode,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getFeature,
    };
};
export const useSetTscliCommand = (onComplete, onError, featureName, params, viewMode) => _useSetTscliCommandMutation({
    variables: {
        featureName,
        params,
        viewMode,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_setTscliCommand);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useGetFeatureLazyQuery = (featureName, viewMode) => {
    const [_getFeature, { data, error, loading }] = _useGetFeatureLazyQuery({
        variables: {
            featureName,
            viewMode,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getFeature,
        getFeature: () => _getFeature(),
    };
};
//# sourceMappingURL=tscli-service.js.map